<div class="table-container">
  <mat-card>
    <mat-card-title class="p-3">
      <div class="d-flex align-items-center justify-content-between">
        <h2 class="title"><strong>User List</strong></h2>
        <button (click)="onClickCreate()" color="primary" mat-mini-fab>
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-card-title>
    <hr class="bg-gray m-0"/>
    <div class="p-2">
      <mat-form-field class="w-100">
        <input
          (change)="onEnterSearch()"
          [(ngModel)]="searchData"
          autocomplete="off"
          matInput
          placeholder="Search Data"
        />
      </mat-form-field>
    </div>
    <mat-card-content>
      <table [dataSource]="dataSource" mat-table>
        <ng-container matColumnDef="username">
          <th *matHeaderCellDef mat-header-cell>Username</th>
          <td *matCellDef="let dt" mat-cell>{{ dt.username }}</td>
        </ng-container>
        <ng-container matColumnDef="fullName">
          <th *matHeaderCellDef mat-header-cell>Full Name</th>
          <td *matCellDef="let dt" mat-cell>{{ dt.fullName }}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th *matHeaderCellDef mat-header-cell>Email</th>
          <td *matCellDef="let dt" mat-cell>{{ dt.email }}</td>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <th *matHeaderCellDef mat-header-cell>Active</th>
          <td *matCellDef="let dt" mat-cell>
            <div
              [ngClass]="{
                'bg-primary': dt.isActive,
                'bg-danger': !dt.isActive
              }"
              class="badge"
            >
              {{ dt.isActive ? "Active" : "Inactive" }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef mat-header-cell>Actions</th>
          <td *matCellDef="let dt" mat-cell>
            <div class="d-flex">
              <button
                (click)="onClickEdit(dt)"
                aria-label="Edit"
                color="basic"
                mat-icon-button
              >
                <mat-icon>edit</mat-icon>
              </button>
              @if (dt.isActive) {
              <button
                (click)="onClickDelete(dt)"
                color="warn"
                aria-label="Delete"
                mat-icon-button
              >
                <mat-icon>delete</mat-icon>
              </button>
              } @else {
              <button
                (click)="onClickRestore(dt)"
                color="primary"
                aria-label="Restore"
                mat-icon-button
              >
                <mat-icon>restore</mat-icon>
              </button>
              }
            </div>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let dtrow; columns: displayedColumns" mat-row></tr>
      </table>
      <mat-progress-bar
        *ngIf="isLoading"
        mode="indeterminate"
      ></mat-progress-bar>
    </mat-card-content>
    <mat-card-actions>
      <mat-paginator
        #paginator
        [length]="totalData"
        [pageSizeOptions]="pageSizes"
        showFirstLastButtons
      ></mat-paginator>
    </mat-card-actions>
  </mat-card>
</div>
